module.exports = __webpack_public_path__ + "img/banner-1-en-mobile.41d22809.png";